export const QUERY = `
query JwmOverviewMeta($id:ID!) {
  jira {
    overview: jwmOverview(id: $id) {
      __typename
      ... on JiraWorkManagementGiraOverview {
        projects {
          edges {
            node {
              projectId
              lead {
                accountId
                name
                picture
              }
            }
          }
        }
      }
      ... on QueryError {
        message
        extensions {
          errorType
          statusCode
        }
      }
    }
  }
}
`;
